var _g, _g2, _g3, _circle, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepsBgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 1736,
    viewBox: "0 0 375 1736",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_724_90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-389 849.15C-389 738.107 -221.61 605 -104.363 605C12.884 605 80 716.781 80 827.824C80 938.867 9.80603 1058 -106.676 1058C-223.158 1058 -389 960.193 -389 849.15Z",
    fill: "#52BD95"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter1_f_724_90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.495 334.5C420.747 274.524 358.2 200 420.747 200C483.295 200 534 260.218 534 334.5C534 408.782 483.295 469 420.747 469C358.2 469 150.437 417.674 307.495 334.5Z",
    fill: "#56CCF2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_724_90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.404 225.391L329.325 225.371L328.985 218.651L323.294 215.159L322.983 208.489L317.292 204.996L316.952 198.276L311.369 194.854L310.821 195.178L316.453 198.571L316.744 205.32L322.485 208.783L322.746 215.482L328.487 218.945L328.777 225.695L328.857 225.715L329.404 225.391Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.24 223.126L333.211 223.076L332.87 216.356L327.179 212.864L326.868 206.194L321.177 202.701L320.837 195.982L315.255 192.559L314.707 192.883L320.289 196.305L320.629 203.025L326.321 206.517L326.631 213.187L332.322 216.68L332.663 223.4L332.742 223.42L333.24 223.126Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.583 230.01L321.554 229.961L321.213 223.241L315.522 219.748L315.212 213.078L309.52 209.586L309.18 202.866L303.548 199.473L303.05 199.767L308.632 203.19L308.973 209.91L314.664 213.402L314.974 220.072L320.665 223.564L321.006 230.284L321.085 230.305L321.583 230.01Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.469 227.716L325.389 227.695L325.099 220.946L319.358 217.483L319.097 210.784L313.356 207.321L313.066 200.571L307.433 197.178L306.935 197.473L312.518 200.895L312.858 207.615L318.549 211.107L318.86 217.777L324.551 221.27L324.891 227.989L324.921 228.039L325.469 227.716Z",
    fill: "#EB5757"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5474,
    cy: 1696.55,
    r: 2.5474,
    fill: "#19C1F3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.0305,
    cy: 1731.48,
    r: 4.36697,
    fill: "#EB5757"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_724_90",
    x: -689,
    y: 305,
    width: 1069,
    height: 1053,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_724_90"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_724_90",
    x: 50,
    y: 0,
    width: 684,
    height: 669,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_724_90"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_724_90"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.4653,
    height: 17.2987,
    fill: "white",
    transform: "translate(317.895 191) rotate(59.434)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepsBgMobile);
export default __webpack_public_path__ + "static/media/StepsBGMobile.b116bec2a48ba727e9876314fad323bf.svg";
export { ForwardRef as ReactComponent };